import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const CallToAction = () => {
  return (
    <section id="kontakt" className="bg-slate-900 overflow-hidden relative py-32">
      {/* Decorative SVG background */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <svg fill="none" viewBox="0 0 400 400" className="absolute top-0 right-0 w-96 h-96 transform translate-x-1/3 -translate-y-1/3">
          <circle cx="200" cy="200" r="200" stroke="currentColor" strokeWidth="1" className="text-slate-400" />
          <circle cx="200" cy="200" r="150" stroke="currentColor" strokeWidth="1" className="text-slate-500" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-5xl font-black tracking-tight text-white sm:text-7xl mb-8">
            Skal vi skabe <span className="text-slate-400 underline decoration-slate-600">resultater</span> sammen?
          </h2>
          <p className="text-xl text-slate-300 mb-12 leading-relaxed max-w-2xl mx-auto font-light">
            Find en tid i min kalender herover, eller skriv direkte til mig hvis du har et konkret projekt i tankerne.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <motion.a 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="#booking"
              className="w-full sm:w-auto inline-flex items-center justify-center px-12 py-6 border border-transparent text-lg font-black rounded-full text-slate-900 bg-white hover:bg-stone-100 transition-all duration-300 shadow-2xl"
            >
              <SafeIcon name="Calendar" className="mr-3 h-6 w-6" />
              Book tid nu
            </motion.a>
            <motion.a 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="mailto:olkjaer@hotmail.com"
              className="w-full sm:w-auto inline-flex items-center justify-center px-12 py-6 border-2 border-slate-700 text-lg font-bold rounded-full text-white transition-all duration-300"
            >
              <SafeIcon name="Mail" className="mr-3 h-6 w-6" />
              olkjaer@hotmail.com
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;